<!-- ScrollToTopButton.vue -->
<template>
    <div class="container is-hidden-desktop">
        <div class="columns m-0">
            <div class="column is-flex is-justify-content-flex-end p-0">
                <div class="nuevo-sucursales">
                    <button 
                        id="scrollToTopBtn" 
                        type="button" 
                        class="button is-default" 
                        title="Volver arriba"
                        @click="scrollToTop"
                    >
                        <span class="text">
                            Subir
                        </span>
                        <span class="icon">
                            <img :src="'/images/Frame1.svg'" alt="Volver arriba" class="image is-16x16" />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScrollToTopButton',
    methods: {
        scrollToTop(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
}
</script>